import * as PIXI from "pixi.js";
import {Assets} from "pixi.js";
import {app, events, iconSizes, modal} from "../../utils/pixiApp";
import {QuestionsModalComponent} from "../modals/QuestionsModalComponent";
import {getDeviceMedia} from "../../utils/sizes";

const questionButton = {
    default: 'questionDefault',
    hover: 'questionHover',
}

export class Question extends PIXI.Container {
    constructor(heightContainer) {
        super();
        this.media = getDeviceMedia(app.screen.width)
        this.img = new PIXI.Sprite(Assets.get(questionButton.default));
        this.img.setSize(iconSizes[this.media].questionIcon.size, iconSizes[this.media].questionIcon.size);
        this.img.anchor.set(0, 0.5);
        this.img.position.x = iconSizes[this.media].questionIcon.positionLeft;
        this.img.position.y = heightContainer / 2;
        this.img.eventMode = 'static';
        this.img.cursor = 'pointer'
        this.addChild(this.img);

        this.img.on("pointerdown", this.onClick.bind(this));
        this.img.on("pointerover", this.onHover.bind(this));
        this.img.on("pointerout", this.onLeave.bind(this));

        events.onScreenResizeEvent(() => {
            this.resizeView();
        })
    }

    onClick() {
        const QMComponent = new QuestionsModalComponent()
        modal.onEmitIsOpenEvent(true, QMComponent)
    }

    onHover() {
        this.img.texture = Assets.get(questionButton.hover);
    }

    onLeave() {
        this.img.texture = Assets.get(questionButton.default);
    }

    resizeView() {
        const media = getDeviceMedia(app.screen.width)
        if(this.media !== media) {
            this.media = media;
            this.img.setSize(iconSizes[this.media].questionIcon.size, iconSizes[this.media].questionIcon.size);
            this.img.position.x = iconSizes[this.media].questionIcon.positionLeft;
            this.img.position.y = media === 'web' ? 80 / 2 : 56 / 2
        }
    }
}